import _ from 'lodash';
// const grayLoggerClient = require('../../../../utils/logger');

// Autocomplete JQueryUI
export default async function initAutocomplete() {
  const threats = await fetch('/malware-trends/tags', { method: 'GET' }); // get all threats tags GET Request
  try {
    const res = await threats.json();

    $('#search').autocomplete({
      source: (req, next) => {
        const trimmedTag = req.term.trim().toLowerCase().replace(/\s/gi, '');
        const tags = _.filter(res.data, (tag) => tag.includes(trimmedTag));

        next(tags);
      },
      select: () => {
        $('#search').trigger('change');
      },
    });
  } catch (err) {
    // grayLoggerClient('error', err.message, { stack: err.stack });
  }
}
